import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import CustomSelect from "../search-filter/others/customSelect.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
import {
    injectIntl,
    defineMessages,
} from 'react-intl'

const uuidv4 = require('uuid/v4')
const messages = defineMessages({
    "invoices": {
        id: "breadcrumbs.invoices",
        defaultMessage: "Invoices",
    },
    "quotes": {
        id: "breadcrumbs.quotes",
        defaultMessage: "Quotes",
    },
    "orders": {
        id: "breadcrumbs.orders",
        defaultMessage: "Orders",
    },
})

class InlineEditSchedulingAvailableFrom extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            document: "-",
            documentId: this.props.documentId || [],
            endPoint: this.props.endPoint || '',
            temporalSelection: this.props.documentId,
            field: this.props.field || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            success: false,
            options: [
                { value: "invoices", label: this.props.intl.formatMessage(messages["invoices"]) },
                { value: "quotes", label: this.props.intl.formatMessage(messages["quotes"]) },
                { value: "orders", label: this.props.intl.formatMessage(messages["orders"]) }
            ]
        }


        this.handleDocumentSelectChange = this.handleDocumentSelectChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.getLabels = this.getLabels.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        const defaultCallback = () => { }
        this.onSave = this.props.onSave || defaultCallback
    }

    getLabels(documentId) {
        let labels = []
        let finalLabel = "-"
        this.state.options.forEach(d => {
            if (documentId && documentId.includes(d.value)) {
                labels.push(d.label)
            }
        })
        finalLabel = (labels.length == 1) ? labels[0] : (labels.length > 1 ? labels.join(',') : "-")
        return finalLabel
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            document: this.getLabels(nextProps.documentId),
            documentId: nextProps.documentId,
            temporalSelection: nextProps.documentId,
            endPoint: nextProps.endPoint || '',
            field: nextProps.field || '',
        })
    }

    componentDidMount() {
        this.setState({ document: this.getLabels(this.state.documentId) })
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleDocumentSelectChange(documentId) {
        this.setState({
            temporalSelection: documentId
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
        })
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: this.state.temporalSelection,
        }).then((r) => {
            if (!r.error) {
                this.setState({
                    documentId: r.attributes && r.attributes[this.state.field] ? r.attributes[this.state.field] : [],
                    document: r.attributes && r.attributes[this.state.field] ? this.getLabels(r.attributes[this.state.field]) : "-",
                    temporalSelection: r.attributes && r.attributes[this.state.field] ? r.attributes[this.state.field] : [],
                    editMode: false,
                    isLoading: false,
                    success: true,
                }, () => {
                    this.onSave(this.state)
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1500)
                })

            } else {
                this.setState({ success: false })
            }
        })

    }

    render() {
        let document = this.state.document
        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {document} {!this.state.success ? <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'} className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />}
            </a>
            document = <span>
                {link}
                <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')} style={{ width: '350px' }}>
                    <div className="w-100 m-0">
                        <CustomSelect
                            multi={true}
                            value={this.state.temporalSelection}
                            options={this.state.options}
                            onChange={this.handleDocumentSelectChange}
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={this.save}
                            isLoading={this.state.isLoading}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        }

        return document
    }

}

export default injectIntl(InlineEditSchedulingAvailableFrom)





// WEBPACK FOOTER //
// ./src/common/inline-edit/document.component.jsx